<template>
  <simple-input
    v-model="email"
    :error="$v.email.$error"
    :placeholder="$t('enter.email.for.receipt')"
    :class="$style.container"
    last-in-form
    autofocus
    @focus="$v.email.$reset"
    @blur="$v.email.$touch"
    @submit="handleSubmit"
  >
    <base-button slot="icon-right" :disabled="isInvalid" @click="handleSubmit">
      <send-icon v-fill="isInvalid ? 'grey-1' : 'violet'" />
    </base-button>
  </simple-input>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';

import SendIcon from 'atoms/icons/basic/Send';
import BaseButton from 'atoms/base/BaseButton';
import SimpleInput from 'molecules/common/SimpleInput';

export default {
  name: 'InputtingRecipientEmail',
  components: {
    SendIcon,
    BaseButton,
    SimpleInput,
  },
  data() {
    return {
      email: '',
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  computed: {
    isInvalid() {
      return this.$v.email.$invalid;
    },
  },
  methods: {
    handleSubmit() {
      if (this.isInvalid) {
        return;
      }

      this.$emit('submit', {
        email: this.email,
        status: 'LOADING',
      });
    },
  },
};
</script>

<style lang="sass" module>
  .container
    // TODO: согласовать с дизайнерами единый размер шрифтов для компонента SimpleInput
    input
      +font-size(14)

      +respond-to('medium')
        +font-size(16)
</style>
